import React from 'react'
import styled from '@emotion/styled'
import { IconButton } from 'view/components/buttons'
import { iconSet } from 'view/components/icons'
import * as constants from 'view/styles/constants'

const TearoutIconButton = styled(IconButton)`
  color: ${constants.CORE_PRIMARY_3};
  svg {
    width: 21px;
    height: 21px;
  }
  &:hover {
    color: ${constants.ACCENT_PRIMARY};
  }
`

interface TearoutButtonProps {
  className?: string
  onTearout: () => unknown
}

export const TearoutButton: React.FunctionComponent<TearoutButtonProps> = props => (
  <TearoutIconButton className={props.className} onClick={props.onTearout} dataTestId="btnTearout">
    {iconSet.restoreIcon}
  </TearoutIconButton>
)
